import React from 'react';
import MapsContainer from "../../components/Posts/MapContainer";
import '../../font-cabinsketch.css'
import './../Post.css';

const Posts: React.FC = () => {
    return (
        <MapsContainer/>
    )
};

export default Posts;